import React from 'react';
import FestivalForm from './FestivalForm';
import { connect } from 'react-redux';
import {
  Grid,
  Row,
  Col
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import { festivalActions } from 'redux/actions/festival-action';

class AddFestivalPage extends React.Component {
	constructor(props){
		super(props);
		this.state = {
			festival : {},
			companyId :this.props.userAdmin.user.company_id,
			adminType : this.props.adminType
		};
		this.handleAction = this.handleAction.bind(this);
		this.props.getPricePerAdjudicationValueCall(this.state.companyId);
	};
	handleAction(festivalData){
		this.props.storeFestivalCall(festivalData, this.state.companyId);
		// const { dispatch } = this.props;

		// console.log('state data', this.state);
	    // dispatch(festivalActions.storeFestival(festivalData, this.state.companyId));
	};
	render(){
		const { adminType } = this.state;
		const { pricePerAdjudicator } = this.props;
		return(
			<div className="content">
	        	<Grid fluid>
	          		<Row>
	            		<Col md={12}>
	              			<Card
				                title="Add Festival"
				                content={
				                	<div>
			                            <Grid fluid>
			                                <Row>
			                                	<Col md={12}>
			                                		<FestivalForm 
			                                			handleActionParent={this.handleAction} 
			                                			festivalDataFP = {this.state.festival} 
			                                			adminTypeData={adminType}
			                                			formType = "add"
			                                			pricePerAdjudicator = { pricePerAdjudicator }
			                                		/>
			                                	</Col>
			                                </Row>
			                            </Grid>
			                        </div>
				                }
				            />
	             		</Col>
	            	</Row>
	          	</Grid>
	        </div>
		);
	};
}
const mapDispatchToProps = dispatch => {
  return ({
    getPricePerAdjudicationValueCall  : (companyId) => { dispatch(festivalActions.getPricePerAdjudicationValue(companyId)) },
    storeFestivalCall  : (festivalData, companyId) => { dispatch(festivalActions.storeFestival(festivalData, companyId)) },
  });
};
function mapStateToProps(state) {
    const { loading, pricePerAdjudicator } = state.festivalReducer;
    const { adminType, userAdmin } = state.adminReducer;
    return {
        loading, adminType, userAdmin, pricePerAdjudicator
    };
}

const AddFestival = connect(mapStateToProps, mapDispatchToProps)(AddFestivalPage);
export default AddFestival;


// WEBPACK FOOTER //
// ./src/components/Admin/Festival/AddFestival.jsx